<div *ngIf="isVisible" class="target">
    <div class="target-point"></div>
</div>
